/**
 * @Author: Fernando Sanchez
 */
// -- React Stuff -- //
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// -- Material UI Stuff
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
// -- MS Azure Auth Stuff -- //
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
// -- Custom -- //
import LoginMicrosoft from "./pages/LoginMicrosoft/LoginMicrosoft";
import NavigationScroll from "./NewLayout/NavigationScroll";
import themes from "./themes";
// -- Routing -- //
import Routes from './routes';
// -- Styles Stuff -- //
import './App.css';
import { SET_THEME_MODE } from "./store/actions";

const getSystemTheme = () => (
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
);

export default function App() {
    // global
    const customization = useSelector((state) => state.customization);
    const dispatch = useDispatch();

    useEffect(() => {
        const preferredMode = localStorage.getItem('themeMode') || customization.themeMode || 'system';
        const mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

        const applyThemeMode = () => {
            dispatch({
                type: SET_THEME_MODE,
                themeMode: preferredMode,
                navType: preferredMode === 'system' ? getSystemTheme() : preferredMode
            });
        };

        applyThemeMode();

        if (preferredMode !== 'system' || !mediaQuery) {
            return undefined;
        }

        mediaQuery.addEventListener('change', applyThemeMode);

        return () => mediaQuery.removeEventListener('change', applyThemeMode);
    }, [customization.themeMode, dispatch]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <AuthenticatedTemplate>
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <LoginMicrosoft/>
                </UnauthenticatedTemplate>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
